import firebase from 'firebase'

// firebase init goes here
const config = {
    apiKey: "AIzaSyDK4WntX66c65WQdHMEzGuqO2tUGeOvFx8",
    authDomain: "scf-custom.firebaseapp.com",
    databaseURL: "https://scf-custom.firebaseio.com",
    projectId: "scf-custom",
    storageBucket: "scf-custom.appspot.com",
    // messagingSenderId: "858875175435"
}
const firebaseApp = firebase.initializeApp(config)
// firebaseApp.firestore().settings({ timestampsInSnapshots: true })
const db = firebaseApp.firestore()
const storageRef = firebase.storage().ref()

export {db, storageRef}
